let callbacks = [];

export function addUnloadListener(callback) {
  callbacks.push(callback);
  window.addEventListener("beforeunload", callback);
}

export function removeUnloadListener(callback) {
  const index = callbacks.indexOf(callback);
  if (index > -1) callbacks.splice(index, 1);
  window.removeEventListener("beforeunload", callback);
}

export function removeAllUnloadListeners() {
  callbacks.forEach(cb => {
    removeUnloadListener(cb);
  });
}
